var timeoutInterceptor = function timeoutInterceptor(err) {
  if (err.code === 'ECONNABORTED') {
    err.name = ''; // setting empty string as names stops the .toString() method prefixing 'Error: '
    err.message = "Dang! Looks like we're having trouble connecting you. Please try again. Still not working? Drop us a line at hello@huggg.me.";
  }
  return Promise.reject(err);
};
export default timeoutInterceptor;